import { NEXT } from './direction';
/**
 * this algorithm is based on scrolling the carousel
 * by a specified length/distance (in pixels)
 * in either next or previous direction.
 */
export default class PixelBasedScrolling {
  // eslint-disable-next-line class-methods-use-this
  scroll(container, direction, distance) {
    if (direction === NEXT) {
      container.parentElement.scrollBy({
        left: distance,
        behavior: 'smooth',
      });
    } else {
      container.parentElement.scrollBy({
        left: -distance,
        behavior: 'smooth',
      });
    }
  }
}
